import React from "react";
import { Button, Col, Form, Row, Select } from "antd";
import { Collapse } from "antd";
import FilterContainer from "../../../../components/common/FilterContainer";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { pricingMetricsCollapse } from "./pricingMetricsData";
import DemandInLastSevenDays from "./components/DemandInLastSevenDays";
import OccupancyInformation from "./components/OccupancyInformation";
import PricePerSquareFoot from "./components/PricePerSquareFoot";
import RentPricingCalculator from "./components/RentPricingCalculator";

import './style.css'
const PricingMetricsRightBar = [
  RightBarMethod(
    " HELP TOPICS",
    "t1",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Pricing Metrics Dashboard", "1", "", "", "/")]
  ),
];

const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
function PricingMetrics() {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <>
      <div>
        <PageHeading heading="Pricing Metrics" />
        <Row>
          <Col span={24}>
            <FilterContainer heading="Filter data shown by using any of the search filters below">
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Property">
                      <Select
                        showSearch
                        placeholder="Search by property, group, or portfolio"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                        options={[]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item label=" ">
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <div className="collapse-container">
          {pricingMetricsCollapse.map((data) => {
            return (
              <><Collapse
                expandIcon={({ isActive }) => isActive ? <RiArrowUpSLine /> : <RiArrowDownSLine />}
                onChange={onChange}
                defaultActiveKey={data.key}
              >
                <Panel header={data.header} key={data.key}>
                  {data.header === "Demand in the Last 7 Days" && <DemandInLastSevenDays/>}
                  {data.header === "Occupancy Information" && <OccupancyInformation/>}
                  {data.header === "Price per Square Foot" && <PricePerSquareFoot/>}
                  {data.header === "Rent Pricing Calculator" && <RentPricingCalculator/>}
                </Panel>
              </Collapse><br /></>
            );
          })}
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PricingMetricsRightBar} />
      </div>
    </>
  );
}

export default PricingMetrics;
